export const DietFilterTag = (json: IDietFilterTag): IDietFilterTagModel => {
	const fromJSON = () => {
		const { name, model_type, ...rest } = json
		return {
			name: LangContentToModel(name),
			modelType: model_type,
			kind: 'filter' as const,
			...rest,
		}
	}

	return { ...fromJSON() }
}

export const DietMarketingTag = (json: IDietMarketingTag): IDietMarketingTagModel => {
	const fromJSON = () => {
		const { name, model_type, ...rest } = json
		return {
			name: LangContentToModel(name),
			modelType: model_type,
			kind: 'marketing' as const,
			...rest,
		}
	}

	return { ...fromJSON() }
}

export const DietDietaryTag = (json: IDietDietaryTag): IDietDietaryTagModel => {
	const { name, ...rest } = json

	return {
		name: LangContentToModel(name),
		kind: 'dietary',
		...rest,
	}
}

/**
 * Payloads
 */
export const DietTagToCreatePayload = (model: IDietTagForm): IDietTagCreatePayload => {
	const name = LangContentToCreatePayload(model)

	return {
		name,
		model_type: model?.modelType ?? undefined,
	}
}

export const DietTagToUpdatePayload = (
	updated: IDietFilterTagModel | IDietMarketingTagModel | IDietDietaryTagModel | null,
	model: IDietTagForm,
): IDietTagUpdatePayload => {
	const name = LangContentToUpdatePayload(model, updated)

	return {
		name,
		model_type: model?.modelType ?? undefined,
	}
}
